import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';

export const FloatingContact = () => {
  return (
    <Link
      to="/contact"
      data-testid="floating-contact-btn"
      style={{
        position: 'fixed',
        bottom: '80px',
        right: '24px',
        zIndex: 9998
      }}
      className="flex items-center gap-2 px-4 py-3 bg-primary text-black font-mono uppercase tracking-wider text-sm font-bold hover:bg-primary/90 transition-all hover:scale-105 shadow-lg hover:shadow-primary/30"
    >
      <MessageCircle size={20} />
      <span className="hidden sm:inline">Contact Us</span>
    </Link>
  );
};
